import { useContext, useEffect } from 'react';

import { get } from '../utils';
import HierarchyContext from './HierarchyContext';

export interface AreaConfig {
  name: string;
  active?: boolean;
  source?: () => any;
  params?: (values: any, depends: string[]) => any;
  depends?: string[];
}

const defaultParams = (values: any, depends: string[]) => {
  if (!depends) {
    return null;
  }
  return depends.reduce((m: any, key: string) => {
    const value = get(values, key);
    if (value !== undefined && value?.length !== 0) {
      return {
        ...m,
        [key]: value,
      };
    }
    return m;
  }, {});
};

export const useArea = ({
  active,
  name,
  source,
  depends,
  params = defaultParams,
}: AreaConfig) => {
  const { register, unregister, state } = useContext(HierarchyContext);

  useEffect(() => {
    if (active) {
      register(name, {
        name,
        source,
        depends,
        params,
      });
    }
    return () => {
      if (active) {
        unregister(name);
      }
    };
  }, [active]);

  return get(state, name);
};
